import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Form, Input, Row, Select, Spin, Typography, Upload, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, getUPLOADAPI, setPath, titleWeb } from "../../services/hello-api";
import { IoArrowBack } from "react-icons/io5";

class MaterialForm extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'add' ? 'Adicionar' : 'Editar',
        defaultValue: null,
        doc: false,
        type: '',
        fileList: [],
        filters: { TYPE_ACCOUNT_ID: [] }
    }

    back = "/dashboard/proposta/material";

    componentDidMount = () => {
        titleWeb('Agências')
        setPath('material')
        this.onFilters()
        if (this.props.type === 'add') {
            this.setState({_screen: false})
        } else if (this.props.type === 'edit') {
            this.onView()
        }
    }

    onFilters = () => {
        POST_API('/material/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onView = async () => {
        POST_API('/material/search.php', { token: getToken(), type: 'view', filter: JSON.stringify({ID: this.state._params[6]}) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data, type: res.data.TYPE})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        POST_API('/material/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    render = () => {

        const routes = [
            {title: <Typography className="page-bread">Proposta</Typography>},
            {title: <Link to={this.back}><Typography className="page-bread">Material</Typography></Link>},
            {title: <Typography className="page-bread active">{this.state._type}</Typography>},
        ]

        if (this.state._navigate) {
            return (<Navigate to={this.back} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to={this.back}><FloatButton className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} align={'bottom'}>
                        { this.state._screen ? <Col span={24}><center><Spin /></center></Col> : (
                            <Col span={24}>
                                <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]}>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Tipo" name="TYPE" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select onChange={(v) => this.setState({type: v})}>
                                                    <Select.Option value={'F'}>Arquivo</Select.Option>
                                                    <Select.Option value={'P'}>Pasta</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        { this.state.type === 'P' ? (
                                            <Col md={20} xs={24}>
                                                <Form.Item label="Nome" name="NAME" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        ):  null }
                                        { this.state.type === 'F' ? (
                                            <>
                                                <Col md={20} xs={24}>
                                                    <Form.Item label="Nome" name="NAME" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col md={12} xs={24}>
                                                    <Form.Item label="Pasta" name="MATERIAL_ID" class="profile-form-item">
                                                        <Select allowClear>
                                                            { this.state.filters.MATERIAL_ID.map((v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option>) }
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col md={12} xs={24}>
                                                    <Form.Item label="Arquivo" name="URL" class="profile-form-item" rules={[{required: (this.props.type === 'add'), message: 'Campo obrigatório*'}]}>
                                                        <Upload maxCount={1} action={getUPLOADAPI}>
                                                            <Button>Selecionar arquivo</Button>
                                                        </Upload>
                                                    </Form.Item>
                                                </Col>
                                            </>
                                        ):  null }
                                        <Col span={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        )

    }

}

export default MaterialForm;